"use strict"

import { EnvStage } from "common-library/ucountit-env"
import { Optional, Required } from "./Environment"
import { createApiUrls } from "./apiurls"

const hostname = "localhost"
const config: EnvStage<Required, Optional> = {
  brand: "ucountit",
  api: Object.assign(createApiUrls(hostname), {}),
  host: ["localhost", "127.0.0.1"],

  redis: {
    host: "127.0.0.1",
    port: "6379",
  },

  log: {
    analyticTrackingId: "",
  },

  email: {
    from: "notification@ucountit.com",
  },

  cloudFront: {
    bucket: "ucount-it.static",
    region: "us-west-1",
    prefix: "ui-local",
    basePath: "https://cdn.retailanalysis.cloud",
  },

  web: {
    faceurl: "/facedashboard",
    tunnelUrl: "http://tunnel.retailanalysis.cloud",
  },

  s3: {
    static: {
      bucket: "ucount-it.stage",
      destination: hostname + "/static",
      region: "us-west-1",
      cloudfront: "",
    },
    firmware: {
      bucket: "ucount-it.stage",
      destination: hostname + "/firmware",
      region: "us-west-1",
    },
    face: {
      bucket: "ucount-it.stage",
      destination: hostname + "/faces",
      region: "us-west-1",
    },
    customAgency: {
      bucket: "ucount-it.stage",
      destination: hostname + "/customAgency",
      region: "us-west-1",
    },
  },

  address: {
    key: "U01TX0FVVEgyMDI1MTAyMTEyMTcwMzExNjM0Nzc=",
  },
}

export default config
